<template>
  <div class="contentPolicy">
    <!-- H5 版本 
    <div id="J_mobile" class="fn-hide tab animated fast">
      <div id="iotHeight"></div>
       此处添加协议内容
      <h4>聚牧城隐私政策</h4>
      <p>
聚牧城网站（www.jumuc.com，以下简称本站）非常注重保护用户（包括但不限于通过有线或移动设备访问本平台的个人及企业）的个人信息及隐私。鉴于您在使用我们的服务时，我们可能会收集和使用您的相关信息，为向您阐明用户信息收集、使用、共享、管理及保护的规则，特制定本《聚牧城隐私政策》（以下或称“本政策”）。并特别提醒您：本政策不适用于其他第三方向您提供的服务。

本政策与用户所使用的本平台服务信息相关，在使用聚牧城各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务，特别应重点阅读以粗体标示的条款。一旦您开始使用聚牧城各项产品或服务，即表示您已充分理解并同意本政策。

如对本政策或相关事宜有任何问题，请通过客服热线：400-888-3088与本平台联系。
一、用户信息的收集及使用
本平台提供服务时，可能会收集、储存和使用下列与用户有关的信息。如果用户不提供相关信息，可能无法注册成为本平台的会员或无法享受本平台提供的某些服务，或者无法达到相关服务拟达到的效果。
1、用户主动提供的信息
当您使用账号注册功能时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括：手机号码、联系人姓名、验证码匹配结果，并创建密码。您的密码将以加密形式进行自动存储、传输、验证，我们不会以明文方式存储、传输、验证您的密码。您在保管、输入、使用您的密码时，应当对物理环境、电子环境评估，以防密码外泄。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的服务，并保护您的账号安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的部分功能，请您谨慎考虑后再提供。同时，您也可以在注册时或后续使用过程中填写或补充您的性别、昵称、头像、生日、个性签名信息，如您未填写或后续删除、变更此类信息的，不会影响注册及产品功能（如订单确认）的正常使用。同时如果您仅需要使用浏览、搜索基本服务，您可以不注册为我们的用户。
2、平台获取的用户信息
2.1基于设备相册权限的附加业务功能
当您上传/更新账号头像、保存商品图片业务功能时，我们将需要获取您的设备相册权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相册权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
2.2基于设备相机权限的附加业务功能
当您拍摄功能、上传/更新账号头像、扫一扫（用于授权设备登录、扫码下载、AR识别等）、图文/视频制作与发布业务功能时，我们将需要获取您的设备相机权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相机权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限。“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
2.3基于设备麦克风权限的附加业务功能
当您使用在线客服沟通业务功能时，我们将需要获取您的设备麦克风权限，并收集您的语音信息、语音交互信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。麦克风权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
2.4基于位置权限的附加业务功能
在我们的特定服务中，我们需要申请获取您的位置权限，并在您授权后收集您的位置信息。位置权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
2.5基于交易信息的附加业务功能
当您在我们的产品与/或服务中购买商品或服务的，我们需要根据商品或服务类型收集如下部分或全部的个人信息，包括：交易商品或服务信息、收货人信息（收货人姓名、收货地址及其联系电话）（个人敏感信息）、交易金额、下单时间、订单商户、订单编号、订单状态、支付方式、支付账号、支付状态（个人敏感信息），我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客户服务。
在您成功下单后，如商品系第三方卖家提供的或商品需要第三方配送的，我们为了顺利、安全、准确向您完成货物的交付及配送，商家及第三方配送公司在发货及配送环节内不可避免地会获知您的相关配送信息（个人信息）。我们向您承诺，我们会以最大努力保障您的个人信息安全，我们会严格要求商家及第三方配送公司对您的个人信息保密，只以配送之目的获悉和使用，不得对外泄露或做其他任何用途。
2.6设备信息收集
包括设备MAC地址（用于数据的安全校验）、唯一设备识别码（imei、imsi）、设备硬件序列号、Androidid、登录IP地址、设备型号、设备名称、设备标识、浏览器类型和设置、语言设置、操作系统和应用程序版本、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、产品版本号、设备所在位置相关信息（包括您授权我们获取的地理位置信息）、GET-TASK检索应用程序、获取安装应用列表信息。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限并根据您的授权获取相关信息。
2.7日志信息收集
当您使用我们的产品与/或服务时，我们会自动收集您的个人上网记录，并作为有关操作日志、服务日志保存，包括您的浏览记录、分享/互动记录、收藏/关注/访问日期和时间。

我们收集这些信息是为了向您提供我们最核心的服务内容展示/下载服务，如您拒绝提供上述信息和/或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。
3、其他第三方获取得与用户信息
其他方使用本平台的服务时所提供有关用户的共享信息。
我们基于以下特定目的收集而来的信息用于其他目的时，会事先征求您的同意。

支付宝支付SDK
使用目的：帮助用户在应用内使用支付宝支付。
信息类型：设备信息、网络信息、位置信息
官网链接：https://docs.open.alipay.com/
所属公司：蚂蚁集团

微信支付SDK
使用目的：帮助用户在应用内使用微信支付。
信息类型：设备信息、网络信息、位置信息
官网链接：https://open.weixin.qq.com/
所属公司：腾讯

TalkingData应用统计分析SDK
使用目的：用于改进用户体验和数据,涉及隐私。
信息类型：设备信息、应用列表信息
官网链接：http://doc.talkingdata.com/
所属公司：北京腾云天下科技有限公司

GrowingIOSDK
使用目的：会尝试获取获取AndroidId，IMEI信息用于渠道信息，并且采集用户信息进行行为分析。
信息类型：设备信息
官网链接：https://www.growingio.com/
所属公司：北京易数科技有限公司

高德SDK
使用目的：为了向您提供基于位置的相关服务，使用地图、定位、导航、路线规划、搜索、轨迹、路况查询等，用于实现定位功能。
信息类型：设备信息、网络信息、位置信息
官网链接：https://lbs.amap.com/
所属公司：高德软件有限公司

友盟SDK
使用目的：用于统一集成APP第三方登录及分享。
信息类型：设备信息、应用列表信息
官网链接：https://www.umeng.com/
所属公司：北京锐讯灵通科技有限公司

阿里人脸SDK
使用目的：提供实名人脸识别功能，会获取设备码，访问网络状态。
信息类型：设备信息，图像信息
官网链接：https://www.aliyun.com/sswd/618638-1.html
所属公司：阿里云计算有限公司

阿里云语音转文字SDK
使用目的：帮助用户语音转成文字
信息类型：设备信息，语音信息
官网链接：https://www.aliyun.com/sswd/5668978-1.html
所属公司：阿里云计算有限公司

极光SDK
使用目的：极光提供推送服务。
信息类型：设备信息、应用列表信息
官网链接：https://www.jiguang.cn/
所属公司：深圳市和讯华谷信息技术有限公司腾讯

移动推送（信鸽push）SDK
使用目的：推送信息信息类型：设备信息
官网链接：https://cloud.tencent.com/product/tpns/
所属公司：腾讯

QQ分享SDK
使用目的：QQ分享，一键分享
信息类型：设备信息、应用列表信息
所属公司：腾讯

微信分享SDK
使用目的：用于微信分享。
信息类型：设备信息
官网链接：https://open.weixin.qq.com/
所属公司：腾讯

华为推送SDK
使用目的：为了向您及时推送服务通知。
信息类型：设备信息
官网链接：http://doc.yuntongxun.com/p/5a57159b3b8496dd00dd0ceb
所属公司：华为技术有限公司

小米推送SDK
使用目的：为了向您及时推送服务通知。
信息类型：设备信息
官网链接：https://dev.mi.com/console/appservice/push.html
所属公司：小米科技有限责任公司

啄木鸟SDK
使用目的：线上质量监控以及异常定位分析服务，跟踪线上异常，高效定位问题，快速解决问题
信息类型：设备信息
官网链接：http://open-uc.uc.cn/solution/zhuomuniao
所属公司：广州市动景计算机科技有限公司
二、用户信息的共享、转让和公开披露
除以下情况外，我们不会将您的个人信息提供给聚牧城以外的任何个人、公司或组织共享、转让给和公开披露：
(1)	依据本政策或事先已获得您明确的同意或授权；
(2)	根据适用的法律、法规、法律程序的要求、行政或司法的强制性要求所必须时；
(3)	在法律、法规允许的范围内，为维护聚牧城及关联方或合作伙伴、您或其他聚牧城用户或社会公共利益、财产或安全免遭损害时；
(4)	据与您签署的相关协议或其他法律文件的约定；

您理解并同意，根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人/企业信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
三、用户个人信息的保护
1、我们已采取符合法律规定、合理可行的安全防护措施和制度保护您个人信息的安全，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。本平台将利用加密技术来保护用户提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。用户需要了解，用户接入本平台的服务所用的系统和通讯网络，有可能因本平台可控范围外的因素而出现问题。
2、我们会采取合理可行的措施以避免收集无关的个人信息。我们只会在达成本政策所述目的所需期限内保留您的个人信息，除非需要延长保留期或应法律法规的允许或要求。
3、在使用聚牧城服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络聚牧城，以便我们根据您的申请采取相应措施。
4、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以信函、电话、推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
四、用户个人信息的保存、访问和管理
1、用户个人信息的保存
您的个人信息将全部被存储于中华人民共和国境内，但以下情形除外：
(1)	法律法规另有明确规定；
(2)	获得您的明确授权；
(3)	您通过互联网进行跨境交易个人主动行为；
针对以上情形，我们会依据本政策及相关法律法规对您的个人信息提供保护。
2、用户个人信息的访问
您有权通过以下方式访问您的个人信息，但法律法规另有规定，或本政策另有约定除外。
账户信息：若您希望访问或编辑您的账户中的个人基本资料信息，您可登录账号通过“账号管理”执行此类操作。
订单信息：您可登录账号通过“我的订单”访问或查看您的订单记录、交易记录等。
若您无法通过上述路径访问该信息，您可通过聚牧城客服与我们联系。
3、用户个人信息的更正、补充
您可以在我们的产品/或服务中更正/修改您的相关个人信息。为便于您行使您的上述权利，我们为您提供了在线自行更正的方式。
对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行更正/修改，“头像/昵称/姓名/性别/生日/居住地/密码管理”信息在“手机端聚牧城App”中的更正/修改路径为：我的—设置—个人资料/账号与安全；修改完成之后当天内生效。
4、用户个人信息的删除
一般而言，我们只会在法律法规规定或必需且最短的时间内保存您的个人信息。为便于您行使您的删除权，我们为您提供了在线自行删除的方式。删除路径：我的-设置-清除缓存。删除完成之后当天内生效。
对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行删除。一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。
在以下情形下，您可以直接向我们提出删除您个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外。
(1)	我们违反法律法规规定，收集、使用您的个人信息的；
(2)	我们违反了与您的约定，收集、使用您的个人信息的；
(3)	法律法规等规定的其他情形；
(4)	您不在使用我们产品时。
为响应您的上述请求为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
五、Cookie及类似技术的使用
当用户访问设有Cookies装置的本平台时，本平台服务器会自动发送Cookies至用户浏览器中，同时储存进用户的电脑硬盘内，此Cookies便负责记录日后用户访问本平台时的种种操作、浏览消费习惯、信用记录。用户可以随时通过浏览器中自带的清除缓存功能随时删除记录。运用Cookies技术，聚牧城能够为您提供更加周到的服务。聚牧城将运用Cookies技术向用户提供其感兴趣的信息资料或为其储存密码。
六、未成年人的特别注意事项
如果您未满18周岁，您无权使用本平台产品或服务。因此，请您不要在本平台从事交易行为。
七、隐私政策更新
我们鼓励您在每次使用我们的产品或服务时都查阅我们的《聚牧城隐私政策》。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本《聚牧城隐私政策》的条款，该更新构成本《聚牧城隐私政策》的一部分。如该更新造成您在本《聚牧城隐私政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的《聚牧城隐私政策》的约束。
上述的“重大变更”包括但不限于：
我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式；
我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
(1)	个人信息共享、转让或公开披露的主要对象发生变化；
(2)	您参与个人信息处理方面的权利及其行使方式发生重大变化；
(3)	我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
(4)	个人信息安全影响评估报告表明存在高风险时；
(5)	其他重要的或可能严重影响您的个人权益的情况发生时。
八、联系方式
您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
如对本政策或相关事宜有任何问题，请通过客服热线：400-888-3088与本平台联系。

发布日期：2021年11月03日
        </p>
      <div class="iphonex-safe-bottom"></div>
    </div> -->

    <!-- PC 版本 -->
    <div id="J_desktop" class="contentPolicy desktop agreement-group">
      <div class="contentPolicy title-wrap">
        <div class="contentPolicy title">
          <div class="contentPolicy tab-title-pc">
            <!-- pc的tab头部内容 -->
            <h1>聚牧城隐私政策</h1>
            <p>
              <strong>聚牧城</strong>（网址：www.jumuc.com，以下简称本站），由内蒙古聚牧城科技有限责任公司研发和技术支持，本站非常注重保护用户（包括但不限于通过有线或移动设备访问本平台的个人及企业）的个人信息及隐私。<strong>鉴于您在使用我们的服务时，我们可能会收集和使用您的相关信息，为向您阐明用户信息收集、使用、共享、管理及保护的规则</strong>，
              特制定本<strong>《聚牧城隐私政策》</strong>（以下或称“本政策”）。并特别提醒您：本政策不适用于其他第三方向您提供的服务。本政策与用户所使用的本平台服务信息相关，在使用聚牧城各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务，
              <strong>特别应重点阅读以粗体标示的条款</strong>。一旦您开始使用聚牧城各项产品或服务，即表示您已充分理解并同意本政策。如对本政策或相关事宜有任何问题，请通过客服热线：<strong>400-888-3088</strong>与本平台联系。
            </p>
            <p><strong>一、用户信息的收集及使用</strong></p>
            <p>本平台提供服务时，可能会收集、储存和使用下列与用户有关的信息。如果用户不提供相关信息，可能无法注册成为本平台的会员或无法享受本平台提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
            <p>我们会遵循正当、合法、必要的原则，<strong>出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息</strong>。如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</p>
            <p><strong>1、平台需要获取的用户信息</strong></p>
            <p>我们的产品与/或服务包括一些核心功能，这些功能包含了<strong>实现网上购物所必须的功能及保障交易安全所必须的功能</strong>。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</p>
            <p><strong>1.1 实现网上购物所必须的功能</strong></p>
            <p><strong>(1) 账号注册与验证</strong></p>
            <p>当您注册聚牧城账号时，您至少需要向我们提供您准备使用的<strong>聚牧城账号名、手机号码、联系人姓名、收货区域，我们将通过发送短信验证码的方式</strong>来验证您的身份是否有效，并创建账号与密码。您的密码将以加密形式进行自动存储、传输、验证，我们不会以明文方式存储、传输、验证您的密码。您在保管、输入、使用您的密码时，应当对物理环境、电子环境评估，以防密码外泄。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的服务，并保护您的账号安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的部分功能，请您谨慎考虑后再提供。</p>
            <p><strong>(2) 账号登录与验证</strong></p>
            <p>当您成功注册聚牧城账号后，可以使用聚牧城账号登录“聚牧城商城”，登录时您需要向我们提供您的聚牧城账号信息，包括：<strong>账号名、账号密码、手机号码、短信验证码匹配结果，用于证实您的身份并登录</strong>。请您在登录本产品与/或服务前，认真阅读并充分理解本政策的全部内容，在确认充分理解并同意后开始使用。在阅读过程中如您对本政策内容有任何疑问、意见或建议，请联系我们。若您不提供这类信息，您将无法登录和在“聚牧城商城”购买商品，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。</p>
            <p><strong>(3) 商品/服务信息展示和搜索</strong></p>
            <p>为了向您展示商品或者服务，我们会收集您的<strong>设备信息（包括设备名称、设备型号、 MAC 地址及 IMEI 、设备识别码、移动应用列表部分软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络 ID ( PLMN ))、浏览器类型</strong>来对相应的商品或者服务内容进行排序以适应您的设备界面。</p>
            <p>为了向您提供搜索历史、浏览记录、收藏的商品、关注的文章、购物车或订单商品或服务展示服务，我们会收集您的<strong>浏览信息、搜索记录、收藏记录、关注记录、加购信息、订单信息</strong>，并根据这些信息进行数据分析、预测您的偏好特征，在聚牧城服务或者其他第三方应用中向您推送您可能感兴趣的商业推送、商业性短信及其他营销信息。</p>
            <p><strong>(4) 下单及订单管理</strong></p>
            <p>当您准备对您购物车内的商品进行结算时，聚牧城系统会生成您购买商品的订单。您需要在订单中至少填写您的<strong>收货人姓名、收货地址、邮政编码以及手机号码</strong>，同时该订单中会载明订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式；您可以另外填写收货人的联系电话以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。若您需要开具发票，还需要提供<strong>姓名、发票抬头、纳税人识别号以及接收发票的电子邮箱或接收发票开具信息的手机号</strong>；如需开具增值税专用发票还需提供购货单位<strong>注册地址、注册电话、开户银行、银行账号信息</strong>。</p>
            <p>上述所有信息构成您的“订单信息”，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。</p>
            <p><strong>(5) 支付功能</strong></p>
            <p>在您下单后，您可以选择与聚牧城合作的第三方支付机构（包括微信支付和支付宝支付通道，以下称“支付机构”）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的聚牧城订单号与交易金额信息，包括您的<strong>银行卡号、有效期及其他银行卡（含储蓄卡、信用卡）</strong>支付必要信息与这些支付机构共享以实现其确认您的支付指令并完成支付。</p>
            <p><strong>(6) 忘记密码</strong></p>
            <p>当您使用账号忘记密码或找回密码时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括：<strong>手机号码、新密码、验证码匹配结果，用于证实您的身份</strong>，帮您找回聚牧城平台密码。</p>
            <p><strong>1.2 保障建议安全所必须的功能</strong></p>
            <p>为保障您使用我们的产品与/或服务时系统的稳定性和安全性，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们需要收集您的<strong>设备信息（设备型号、设备Mac地址、应用进程列表、设备识别码、设备序列号、操作系统及软件版本、设备状态、网络状况）、日志信息、IP地址、浏览信息、订单信息、ssid、wifi信息、IMSI、SIM卡信息、电池使用情况</strong>来识别是否为真实自然人用户、是否为异常登录、判断您的账号风险，并可能会记录一些我们认为有风险的链接。我们也会收集您的设备信息用于对聚牧城系统问题进行分析、统计流量并排查可能存在的风险。如果您不提供上述信息，我们则无法在您使用聚牧城服务过程中对您的服务及账号安全进行保护。</p>
            <p><strong>1.3 基于设备相册权限的附加业务功能</strong></p>
            <p>当您上传/更新账号头像、保存商品图片、上传交易凭证业务功能时，我们将需要获取您的<strong>设备相册权限，并收集您提供的图片、视频内容信息（个人信息）</strong>。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相册权限是您设备上的一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>1.4 基于设备相机权限的附加业务功能</strong></p>
            <p>当您拍摄功能、上传/更新账号头像、扫一扫（用于图搜商品、授权设备登录、扫码下载、AR识别）、图文/视频制作与发布、上传交易凭证业务功能时，我们将需要获取您的<strong>设备相机权限，并收集您提供的图片、视频内容信息（个人信息）</strong>。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相机权限是您设备上的一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>1.5 基于设备麦克风权限的附加业务功能</strong></p>
            <p>当您使用在线客服沟通业务功能时，我们将需要获取您的<strong>设备麦克风权限，并收集您的语音信息、语音交互信息（个人信息）</strong>。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。麦克风权限是您设备上的一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>1.6 基于位置权限的附加业务功能</strong></p>
            <p>在我们的特定服务中，我们需要<strong>申请获取您的位置权限，并在您授权后收集您的位置信息</strong>。位置权限是您设备上的一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>1.7 基于设备存储文件权限的功能</strong></p>
            <p>当您使用保存图片服务时我们将获取访问您的<strong>设备存储文件相关权限，需要读取您存储的图片文件（个人信息）</strong>。如您拒绝提供仅会使您无法使用该功能，但并不影响您正常使用产品/服务的其他功能。同时，您也可以随时通过您的设备系统或使用我们的产品/服务的相关功能设置页面开启/取消该权限。您开启上述权限即视为您授权我们可以访问、获取、收集、使用您的该等个人信息；您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务。当您更新APP版本后，未经您的明确同意，我们不会更改您之前设置的权限状态。</p>
            <p><strong>1.8 日志信息收集</strong></p>
            <p>当您使用我们的产品与/或服务时，我们会自动收集您的个人上网记录，并作为有关操作日志、服务日志保存，包括您的<strong>浏览记录、分享/互动记录、收藏/关注/访问日期和时间</strong>。
            <p>我们收集这些信息是为了向您提供我们最核心的服务内容展示/下载服务，如您拒绝提供上述信息和/或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。
            <!-- <p><strong>2、平台获取的用户信息</strong></p>
            <p><strong>2.1基于设备相册权限的附加业务功能</strong></p>
            <p>当您上传/更新账号头像、保存商品图片业务功能时，我们将需要获取您的设备相册权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相册权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>2.2基于设备相机权限的附加业务功能</strong></p>
            <p>当您拍摄功能、上传/更新账号头像、扫一扫（用于图搜商品、授权设备登录、扫码下载、AR识别）、图文/视频制作与发布业务功能时，我们将需要获取您的设备相机权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相机权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限。“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>2.3基于设备麦克风权限的附加业务功能</strong></p>
            <p>当您使用在线客服沟通业务功能时，我们将需要获取您的设备麦克风权限，并收集您的语音信息、语音交互信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。麦克风权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>2.4基于位置权限的附加业务功能</strong></p>
            <p>在我们的特定服务中，我们需要申请获取您的位置权限，并在您授权后收集您的位置信息。位置权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，“手机端聚牧城APP”（Android版）的路径为：我的—设置—账号与安全—系统权限管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</p>
            <p><strong>2.5基于交易信息的附加业务功能</strong></p>
            <p>当您在我们的产品与/或服务中购买商品或服务的，我们需要根据商品或服务类型收集如下部分或全部的个人信息，包括：交易商品或服务信息、收货人信息（收货人姓名、收货地址及其联系电话）（个人敏感信息）、交易金额、下单时间、订单商户、订单编号、订单状态、支付方式、支付账号、支付状态（个人敏感信息），我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客户服务。</p>
            <p>在您成功下单后，如商品系第三方卖家提供的或商品需要第三方配送的，我们为了顺利、安全、准确向您完成货物的交付及配送，商家及第三方配送公司在发货及配送环节内不可避免地会获知您的相关配送信息（个人信息）。我们向您承诺，我们会以最大努力保障您的个人信息安全，我们会严格要求商家及第三方配送公司对您的个人信息保密，只以配送之目的获悉和使用，不得对外泄露或做其他任何用途。</p>
            <p><strong>2.6设备信息收集</strong></p>
            <p>包括设备MAC地址（用于数据的安全校验）、唯一设备识别码（imei、imsi）、设备硬件序列号、Androidid、登录IP地址、设备型号、设备名称、设备标识、浏览器类型和设置、语言设置、操作系统和应用程序版本、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、产品版本号、设备所在位置相关信息（包括您授权我们获取的地理位置信息）、GET-TASK检索应用程序、获取安装应用列表信息。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限并根据您的授权获取相关信息。</p>
            <p>同时，为了将重要的服务消息通过个推服务通知到您，个推SDK需要收集IMEI、IMSI、SSID、BSSID、设备MAC地址、软件安装列表、位置、联系人、通话记录、日历、短信、本机电话号码、图片、音视频个人信息、IP地址、WIFI信息、基站信息、设备制造商、设备型号、设备系统信息、设备联网方式和状态信息、设备环境信息，以上信息在收集后会严格按照隐私服务政策使用。</p>
            <p><strong>2.7日志信息收集</strong></p>
            <p>当您使用我们的产品与/或服务时，我们会自动收集您的个人上网记录，并作为有关操作日志、服务日志保存，包括您的浏览记录、分享/互动记录、收藏/关注/访问日期和时间。
            <p>我们收集这些信息是为了向您提供我们最核心的服务内容展示/下载服务，如您拒绝提供上述信息和/或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。 -->
            <p><strong>2、用户自主选择提供的信息</strong></p>
            <p>为使您购物更便捷或更有乐趣，从而提升您在聚牧城的网上购物体验，我们在扩展功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用为您带来购物乐趣的扩展功能或在购买某些商品时需要重复填写一些信息。</p>
            <p>请您注意，<strong>您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务</strong>，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
            <p><strong>3、其他第三方获取得与用户信息</strong></p>
            <p>其他方使用本平台的服务时所提供有关用户的共享信息。我们基于以下特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>

            <div class="contentPolicy" style="margin-top: 20px;">
              <p><strong>神策分析SDK</strong></p> 
              <p>使用目的：<strong>基础行为数据收集与建模，驱动业务决策分析。</strong></p>
              <p>信息类型：<strong>设备信息（IMEI、Android ID、IDFA、IDFV、OAID、UUID、MAC地址、IMSI信息）、日志信息（终端用户对集成神策 SDK 的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器类型和使用的语言、访问服务的时间）、位置信息、唯一应用程序编号、唯一应用程序编号</strong></p>
              <p>隐私政策：<a href="https://www.sensorsdata.cn/market/privacy_policy.html">https://www.sensorsdata.cn/market/privacy_policy.html</a></p>
              <p>所属公司：神策网络科技（北京）有限公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;">   
              <p><strong>个推SDK</strong></p> 
              <p>使用目的：<strong>个推提供推送服务。</strong></p>
              <p>信息类型：<strong>设备信息（IMEI、Android ID、IDFA、IDFV、OAID、Advertising ID、Serial Number、SSID、BSSID、UAID、MAC地址、IMSI信息）、应用列表、网络信息（IP地址、WIFI信息、基站信息）以及位置相关信息、设备弱特征（不具备唯一性和稳定性的特征），含设备信息(设备制造商、设备型号、设备系统信息)、设备网络信息(设备联网方式和状态信息)、设备环境信息(屏幕亮度、电池状态及所在国家、设备应用信息)</strong></p>
              <p>官网链接：<a href="https://www.getui.com/privacy">https://www.getui.com/privacy</a></p>
              <p>所属公司：浙江每日互动网络科技股份有限公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;">
              <p><strong>支付宝支付SDK</strong></p>
              <p>使用目的：<strong>帮助用户在应用内使用支付宝支付。</strong></p>
              <p>信息类型：<strong>设备信息、网络信息、位置信息</strong></p>
              <p>官网链接：<a href="https://docs.open.alipay.com/">https://docs.open.alipay.com/</a></p>
              <p>所属公司：蚂蚁集团</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;">
              <p><strong>微信支付SDK</strong></p> 
              <p>使用目的：<strong>帮助用户在应用内使用微信支付。</strong></p>
              <p>信息类型：<strong>设备信息、网络信息、位置信息</strong></p>
              <p>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></p>
              <p>所属公司：腾讯</p>
            </div>

            <!-- <div class="contentPolicy" style="margin-top: 20px;">
              <p>TalkingData应用统计分析SDK</p>
              <p>使用目的：用于改进用户体验和数据,涉及隐私。</p>
              <p>信息类型：设备信息、应用列表信息</p>
              <p>官网链接：<a href="http://doc.talkingdata.com/">http://doc.talkingdata.com/</a></p>
              <p>所属公司：北京腾云天下科技有限公司</p>
            </diV> -->

            <!-- <div class="contentPolicy" style="margin-top: 20px;"> 
              <p>GrowingIOSDK</p>
              <p>使用目的：会尝试获取获取AndroidId，IMEI信息用于渠道信息，并且采集用户信息进行行为分析。</p>
              <p>信息类型：设备信息</p>
              <p>官网链接：<a href="https://www.growingio.com/">https://www.growingio.com/</a></p>
              <p>所属公司：北京易数科技有限公司 </p>
            </div> -->

            <!-- <div class="contentPolicy" style="margin-top: 20px;">  
              <p>友盟SDK</p>
              <p>使用目的：用于统一集成APP第三方登录及分享。</p>
              <p>信息类型：设备信息、应用列表信息</p> 
              <p>官网链接：<a href="https://www.umeng.com/">https://www.umeng.com/</a></p>
              <p>所属公司：北京锐讯灵通科技有限公司</p>
            </div> -->

            <!-- <div  class="contentPolicy" style="margin-top: 20px;"> 
              <p>高德SDK</p>
              <p>使用目的：为了向您提供基于位置的相关服务，使用地图、定位、导航、路线规划、搜索、轨迹、路况查询等，用于实现定位功能。</p>
              <p>信息类型：设备信息、网络信息、位置信息</p>
              <p>官网链接：<a href="https://lbs.amap.com/">https://lbs.amap.com/</a></p>
              <p>所属公司：高德软件有限公司</p>
            </div> -->
            
            <!-- <div class="contentPolicy" style="margin-top: 20px;"> 
              <p>阿里人脸SDK</p>
              <p>使用目的：提供实名人脸识别功能，会获取设备码，访问网络状态。</p>
              <p>信息类型：设备信息，图像信息</p>
              <p>官网链接：<a href="https://www.aliyun.com/sswd/618638-1.html">https://www.aliyun.com/sswd/618638-1.html</a></p>
              <p>所属公司：阿里云计算有限公司</p>
            </div> -->

            <!-- <div class="contentPolicy" style="margin-top: 20px;">
              <p>阿里云语音转文字SDK</p>
              <p>使用目的：帮助用户语音转成文字</p> 
              <p>信息类型：设备信息，语音信息</p>
              <p>官网链接：<a href="https://www.aliyun.com/sswd/5668978-1.html">https://www.aliyun.com/sswd/5668978-1.html</a></p>
              <p>所属公司：阿里云计算有限公司</p>
            </div> -->

            <!-- <div class="contentPolicy" style="margin-top: 20px;"> 
              <p>移动推送（信鸽push）SDK</p>
              <p>使用目的：推送信息信息类型：设备信息</p>
              <p>官网链接：<a href="https://cloud.tencent.com/product/tpns">https://cloud.tencent.com/product/tpns</a></p>
              <p>所属公司：腾讯</p>
            </div> -->

            <!-- <div class="contentPolicy" style="margin-top: 20px;">
              <p>QQ分享SDK </p>
              <p>使用目的：QQ分享，一键分享</p>
              <p>信息类型：设备信息、应用列表信息 </p>
              <p>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></p>
              <p>所属公司：腾讯</p>
            </div> -->
                
            <div class="contentPolicy" style="margin-top: 20px;">
              <p><strong>微信分享SDK</strong></p>
              <p>使用目的：<strong>用于微信分享。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></p>
              <p>所属公司：腾讯</p>
            </div> 
              
            <div class="contentPolicy" style="margin-top: 20px;">
              <p><strong>华为推送SDK</strong></p>
              <p>使用目的：<strong>为了向您及时推送服务通知。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="http://doc.yuntongxun.com/p/5a57159b3b8496dd00dd0ceb/">http://doc.yuntongxun.com/p/5a57159b3b8496dd00dd0ceb</a></p>
              <p>所属公司：华为技术有限公司</p>
            </div>
              
            <div class="contentPolicy" style="margin-top: 20px;"> 
              <p><strong>小米推送SDK</strong></p>
              <p>使用目的：<strong>为了向您及时推送服务通知。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="https://dev.mi.com/console/appservice/push.html/">https://dev.mi.com/console/appservice/push.html/</a></p>
              <p>所属公司：小米科技有限责任公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;"> 
              <p><strong>OPPO推送SDK</strong></p>
              <p>使用目的：<strong>为了向您及时推送服务通知。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="https://open.oppomobile.com/new/developmentDoc/info?id=11207">https://open.oppomobile.com/new/developmentDoc/info?id=11207</a></p>
              <p>所属公司：OPPO广东移动通信有限公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;"> 
              <p><strong>vivo推送SDK</strong></p>
              <p>使用目的：<strong>为了向您及时推送服务通知。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="https://dev.vivo.com.cn/documentCenter/doc/180">https://dev.vivo.com.cn/documentCenter/doc/180</a></p>
              <p>所属公司：维沃移动通信有限公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;"> 
              <p><strong>移动安全联盟OAID</strong></p>
              <p>使用目的：<strong>会尝试获取设备制造商、设备型号、设备品牌、网络运营商名称，用于判断终端调用接口。</strong></p>
              <p>信息类型：<strong>设备信息</strong></p>
              <p>官网链接：<a href="http://www.msa-alliance.cn/col.jsp?id=122">http://www.msa-alliance.cn/col.jsp?id=122</a></p>
              <p>所属公司：移动安全工作委员会</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;"> 
              <p><strong>AndroidX Webkit（chromium）</strong></p>
              <p>使用目的：<strong>谷歌公司提供的AndroidX辅助开发工具，基于WebKit浏览器引擎，提供网页浏览服务。</strong></p>
              <p>信息类型：<strong>设备信息（SSID，BSSID，MAC地址，WIFI信息），剪切板</strong></p>
              <p>官网链接：<a href="https://developer.android.google.cn/jetpack/androidx">https://developer.android.google.cn/jetpack/androidx</a></p>
              <p>所属公司：谷歌公司</p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;">  
              <p><strong>Glide Mocks SDK</strong></p>
              <p>使用目的：<strong>为实现APP在安卓系统运行下的基础框架功能，用于图片加载功能。</strong></p>
              <p>信息类型：<strong>读取与写入外部存储文件</strong></p> 
              <p>开源链接：<a href="https://github.com/bumptech/glide/">https://github.com/bumptech/glide/</a></p>
            </div>

            <div class="contentPolicy" style="margin-top: 20px;">  
              <p><strong>com.android.internal SDK</strong></p>
              <p>使用目的：<strong>为实现APP在安卓系统运行下的核心框架功能，用于软件正式使用运转。</strong></p>
              <p>信息类型：<strong>获取外部存储目录信息，读取与写入外部存储文件</strong></p> 
              <p>开源链接：<a href="https://github.com/anggrayudi/android-hidden-api/">https://github.com/anggrayudi/android-hidden-api/</a></p>
            </div>

            <p><strong>二、用户信息的共享、转让和公开披露</strong></p>
            <p><strong>除以下情况外，我们不会将您的个人信息提供给聚牧城以外的任何个人、公司或组织共享、转让给和公开披露：</strong></p>
            <p>(1) 依据本政策或事先已获得您明确的同意或授权；</p>
            <p>(2) 根据适用的法律、法规、法律程序的要求、行政或司法的强制性要求所必须时；</p>
            <p>(3) 在法律、法规允许的范围内，为维护聚牧城及关联方或合作伙伴、您或其他聚牧城用户或社会公共利益、财产或安全免遭损害时；</p>
            <p>(4) 据与您签署的相关协议或其他法律文件的约定；</p>
            <p><strong>您理解并同意，根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人/企业信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</strong></p>
            <p><strong>三、用户个人信息的保护</strong></p>
            <p>1、<strong>我们已采取符合法律规定、合理可行的安全防护措施和制度保护您个人信息的安全，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</strong>本平台将利用加密技术来保护用户提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。用户需要了解，用户接入本平台的服务所用的系统和通讯网络，有可能因本平台可控范围外的因素而出现问题。</p>
            <p>2、<strong>我们会采取合理可行的措施以避免收集无关的个人信息。</strong>我们只会在达成本政策所述目的所需期限内保留您的个人信息，除非需要延长保留期或应法律法规的允许或要求。</p>
            <p>3、在使用聚牧城服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址，<strong>请您妥善保护自己的个人信息，仅在必要情形下向他人提供。</strong>如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络聚牧城，以便我们根据您的申请采取相应措施。</p>
            <p>4、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：<strong>安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。</strong>事件相关情况我们将以信函、电话、推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
            <p><strong>四、用户个人信息的保存、访问和管理</strong></p>
            <p><strong>1、用户个人信息的保存</strong></p>
            <p>您的个人信息将全部被存储于中华人民共和国境内，但以下情形除外：</p>
            <p>(1) 法律法规另有明确规定；</p>
            <p>(2) 获得您的明确授权；</p>
            <p>(3) 您通过互联网进行跨境交易个人主动行为；</p>
            <p>针对以上情形，<strong>我们会依据本政策及相关法律法规对您的个人信息提供保护。</strong></p>
            <p><strong>2、用户个人信息的访问</strong></p>
            <p>您有权通过以下方式访问您的个人信息，但法律法规另有规定，或本政策另有约定除外。</p>
            <p>账户信息：<strong>若您希望访问或编辑您的账户中的个人基本资料信息，您可登录账号通过“账号管理”执行此类操作。</strong></p>
            <p>订单信息：<strong>您可登录账号通过“我的订单”访问或查看您的订单记录、交易记录等。</strong></p>
            <p>若您无法通过上述路径访问该信息，您可通过聚牧城客服与我们联系。</p>
            <p><strong>3、用户个人信息的更正、补充</strong></p>
            <p>您可以在我们的产品/或服务中更正/修改您的相关个人信息。为便于您行使您的上述权利，我们为您提供了在线自行更正的方式。</p>
            <p>对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行更正/修改，“头像/昵称/姓名/性别/生日/居住地/密码管理”信息在“手机端聚牧城App”中的更正/修改路径为：<strong>我的-设置-个人资料/账号与安全</strong>；修改完成之后当天内生效。</p>
            <p><strong>4、用户个人信息的删除、账号注销</strong></p>
            <p>一般而言，我们只会在法律法规规定或必需且最短的时间内保存您的个人信息。为便于您行使您的个人信息删除权，我们为您提供了在线自行删除的方式。删除路径：<strong>我的-设置-注销账号。</strong>删除完成之后当天内生效。但请您注意：</p>
            <p><strong>(1) 您的账号注销后我们将不在存储和保留您的所有账号个人信息和数据，平台也不再允许注销后的账号登录；</strong></p>
            <p><strong>(2) 如您在注销账号后仍想在次使用服务，只需重新注册账号即可；</strong></p>
            <p>对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行删除。一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。</p>
            <p>在以下情形下，您可以直接向我们提出删除您个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外：</p>
            <p>(1) 我们违反法律法规规定，收集、使用您的个人信息的；</p>
            <p>(2) 我们违反了与您的约定，收集、使用您的个人信息的；</p>
            <p>(3) 法律法规等规定的其他情形；</p>
            <p>(4) 您不在使用我们产品时；</p>
            <p>为响应您的上述请求为保障安全，您可能需要<strong>提供书面请求，或以其他方式证明您的身份。</strong>我们可能会先要求您验证自己的身份，然后再处理您的请求。如有任何疑问，请致电<strong>400-888-3088</strong>咨询。</p>
            <p><strong>5、用户个人信息的超期处理</strong></p>
            <p>我们存储您个人信息的时间不会长于实现本政策所述目的所需的期限，同时会遵守适用的法律法规规定。当存储期限届满或处理目的已完成时，我们将根据法律法规的要求，对您的个人信息采取相应的处理措施：</p>
            <p><strong>(1) 删除</strong>：永久性地消除存储介质中所有相关的个人信息，使其不可恢复；</p>
            <p><strong>(2) 匿名化</strong>：对您的个人信息进行技术处理，使得这些信息无法被识别到特定个人且不能被复原。匿名化处理后的信息将不再属于个人信息，我们可将其用于统计分析等目的；</p>
            <p>在下列情况下，我们可能会延长您的个人信息的存储时间，并在延期届满时及时进行删除或匿名化：</p>
            <p>(1) 为遵守适用的法律法规等有关规定；</p>
            <p>(2) 为遵守法院判决、裁定或其他法律程序的要求；</p>
            <p>(3) 为遵守相关政府机关或法定授权组织的要求；</p>
            <p>(4) 为执行相关服务协议或本政策、维护社会公共利益、处理投诉/纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；</p>
            <p><strong>6、改变授权同意的范围或撤回您的授权</strong></p>
            <p>您可以通过<strong>删除信息、关闭设备功能，在您的设备中进行"权限设置"等方式改变或撤回您对我们继续收集个人信息的授权。</strong>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</p>
            <p>请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
            <p><strong>五、Cookie及类似技术的使用</strong></p>
            <p>Cookie及类似技术的使用当用户访问设有Cookies装置的本平台时，本平台服务器会自动发送Cookies至用户浏览器中，同时储存进用户的电脑硬盘内，<strong>此Cookies负责记录用户的登录信息和访问凭证。</strong>用户可以随时通过浏览器中自带的清除缓存功能随时删除记录。运用Cookies技术为用户其储存登录认证信息。</p>
            <p><strong>六、未成年人的特别注意事项</strong></p>
            <p>如果您未满18周岁，您无权使用本平台产品或服务。因此，请您不要在本平台从事交易行为。</p>
            <p><strong>七、隐私政策更新</strong></p>
            <p>我们鼓励您在每次使用我们的产品或服务时都查阅我们的<strong>《聚牧城隐私政策》</strong>。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本《聚牧城隐私政策》的条款，该更新构成本《聚牧城隐私政策》的一部分。如该更新造成您在本《聚牧城隐私政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，<strong>若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的《聚牧城隐私政策》的约束。</strong></p>
            <p>上述的“重大变更”包括但不限于：</p>
            <p>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式；</p>
            <p>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
            <p>(1) 个人信息共享、转让或公开披露的主要对象发生变化；</p>
            <p>(2) 您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
            <p>(3) 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
            <p>(4) 个人信息安全影响评估报告表明存在高风险时；</p>
            <p>(5) 其他重要的或可能严重影响您的个人权益的情况发生时；</p>
            <p><strong> 八、如何联系我们</strong></p>
            <p>1、如您对本隐私政策或您个人信息的相关事宜进行投诉、举报，或者有任何疑问、意见及建议，请通过<strong>400-888-3088</strong>与我们联系。</p>
            <p>2、一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商监管部门进行投诉或举报。</p>
            <p>发布日期：2025年09月15日</p>
          </div>
        </div>
      </div>

      <!-- <div class="tab-contents">
         pc的tab切换内容
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "policy",
  data() {
    return {};
  },

  // mounted() {
  //   window.fdConfig = [
  //     {
  //       title: "用户服务协议",
  //       content:
  //         '<p style="font-size:16px; text-align:center;"><strong><span style>用户服务协议</span></strong></p>',
  //       default: true,
  //     },
  //     {
  //       title: "聚牧城隐私政策",
  //       content:
  //         '<p style="font-size:16px; text-align:center;"><strong><span style="color:rgb(51, 51, 51);">聚牧城隐私政策</span></strong></p><p style="font-size:16px; text-align:right;"></strong></p>',
  //       language: "zh-Hans",
  //       default: true,
  //     }
  //   ];

  //   var isMobile = window.navigator.userAgent.indexOf("Mobile") > -1;

  //   // 注意: 这里不能使用 $, 会被后续的 Yocto 覆盖
  //   function App() {}

  //   App.prototype.init = function () {
  //     this.$page = jQuery("#J_desktop");
  //     this.initEvent();
  //     return this;
  //   };

  //   App.prototype.initEvent = function () {
  //     var $items = jQuery(".tab-title-pc>.item");
  //     $items.click(function (e) {
  //       var $this = jQuery(e.target);
  //       if ($this.hasClass("active")) {
  //         return;
  //       }

  //       var index = $this.data("index");
  //       $this.siblings().removeClass("active");
  //       $this.addClass("active");
  //       // get content
  //       var $contents = jQuery(".tab-contents>.tab-content");
  //       var $content = $contents.eq(index - 1);
  //       $contents.hide();
  //       $content.show();
  //     });
  //   };

  //   App.prototype.render = function () {
  //     this.show();
  //   };

  //   App.prototype.show = function () {
  //     this.$page.show();
  //   };

  //   if (!isMobile) {
  //     // 获取当前配置的default:true的数据
  //     var curDataAry = getDefinedData();
  //     if (curDataAry && curDataAry.length) {
  //       //  index.html之前的数据逻辑
  //       if (curDataAry.length > 3) curDataAry = curDataAry.splice(0, 3);
  //       renderHtml(curDataAry);
  //       renderContentHtml(curDataAry);
  //     }
  //     new App().init().render();
  //   }

  //   function getDefinedData() {
  //     var allAgreement = fdConfig;
  //     var curDefinedAgreement = allAgreement.filter(function (item) {
  //       return item.default === true;
  //     });
  //     return curDefinedAgreement;
  //   }

  //   //  渲染头部数据
  //   function renderHtml(data) {
  //     var htmlStr = "";
  //     data.forEach(function (item, index) {
  //       var curDataIndex = index + 1;
  //       var curTitle = item.title;
  //       var curStr =
  //         '<span data-index="' +
  //         curDataIndex +
  //         '" class="item">' +
  //         curTitle +
  //         "</span>";
  //       htmlStr += curStr;
  //     });
  //     jQuery(".tab-title-pc").prepend(htmlStr);
  //     jQuery(".tab-title-pc>.item").eq(0).addClass("active");
  //     jQuery(".tab-title-pc>.item").last().addClass("last");
  //   }

  //   //  渲染内容数据
  //   function renderContentHtml(data) {
  //     var htmlStr = "";
  //     data.forEach(function (item, index) {
  //       var curDataIndex = index + 1;
  //       var curContent = item.content;
  //       var curStr =
  //         '<div data-index="' +
  //         curDataIndex +
  //         '" class="tab-content"><div class="content-text">' +
  //         curContent +
  //         "</div></div>";
  //       htmlStr += curStr;
  //     });
  //     jQuery(".tab-contents").prepend(htmlStr);
  //     jQuery(".tab-contents>.tab-content:not(:first)").addClass("fn-hide");
  //   }
  // },

  methods: {},
};
</script>

<style lang="less" scoped>
.contentPolicy {
  width: 100%;
  #J_desktop {
    width: 90%;
    margin-left: 5%;
    h1{
      margin-top: 20px;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 10px;
      text-align: left;
      // text-indent: 30px;
    }
  }
}
</style>
